export const tabContainerClasses = `
    flex
    py-2
    border-b
    border-grayLight
    mb-4
`
